












import ripple from "./ripple.vue"
import warningPopup, {WarningInterface} from "./warningPopup.vue"
import {JobItem} from "../routes/jobView.vue"
import calItem from "./calItem.vue"
import moment,{ weekdays } from "moment";

import { Component, Vue, Prop, Watch} from "vue-property-decorator";
import { nextTick } from "process";
import { setTimeout } from "timers";
import { frontendClient } from "../lib/client";

export let noValueSymbol = Symbol("novalue");

@Component({
    components: {
        warningPopup,
        ripple
    }
})
export default class MoveableItem extends Vue {

    @Prop({}) item:JobItem;
    @Prop({}) multiple:boolean;

    clicked:boolean = false;
    cloneable:Node = (this.$el as Node);
    hidden:boolean = false;
    focused:boolean = false;
    componentKey:number = 0;
    x:number = null;
    y:number = null;
    clone:Element = null;
    cloneXY: {
        x: number,
        y: number
    };
    toInsertBefore:number = null;
    template:Element = null;
    hoveredElem:HTMLElement = null;

    // MOVE WARNING
    moveWarning:WarningInterface=null;

    parentMoveDestination: Date = null;
    readyForUpdate:boolean = false;

    mounted(){
        this.cloneable = (this.$refs.moveable as Node);
        this.getCurrentDestination();
    }

    getCurrentDestination(){
        let found = false;
        let focusElem = this.$el.parentNode;
        if(focusElem == null || focusElem == undefined) {
            frontendClient.giveError("No Parent Element");
        };
        do{
            if((focusElem as HTMLElement).dataset.movedestination){
                found = true;
                this.parentMoveDestination = moment((focusElem as HTMLElement).dataset.movedestination, "DD/MM/YYYY").toDate();
            }else{
                focusElem = focusElem.parentElement;
            }
        }while(found == false);
    }

    shouldStopContinue(){
        this.shouldContinue = false;
    }

    shouldContinue:boolean = true;
    wasReordering:string = null;
    startMove(event:MouseEvent){
        this.shouldContinue = true;
        this.wasReordering = this.$route.params.reodering;

        setTimeout(() => {
            if(this.shouldContinue){
                this.initiateMove(event);
            }else{
                this.shouldContinue = true;
            }
        },150)
    }

    initiateMove(event){
        if(this.wasReordering == "true"){
            return;
        }

        if(event.which != 1 || this.clicked){
            this.clicked = false;
            return;
        }

        let borderBox = (this.cloneable as HTMLElement).getBoundingClientRect();
        this.x = event.pageX - borderBox.left;
        this.y = event.pageY - borderBox.top;

        this.clone = (this.cloneable.cloneNode(true) as Element);
        this.clone.id = "clonedMoveable";
        this.clone.className = "g_moveableClone";

        this.template = (this.cloneable.cloneNode(true) as Element);
        this.template.id = "clonedTemplate";
        this.template.className = "g_moveableTemplate";
        
        (this.clone as HTMLElement).style.width = `${(this.cloneable as HTMLElement).offsetWidth}px`;

        document.body.appendChild(this.clone);

        document.addEventListener('mousemove', this.controlMove);
        document.addEventListener('mouseup', this.dropItem);

        // (this.$refs.moveable as Element).remove() // have to remove as it is recreated by this.moving being set to false again
        this.hidden = true;
        this.controlMove(event);
    }

    controlMove(event:MouseEvent){
        this.cloneXY = {
            x:event.pageX - this.x,
            y:event.pageY - this.y
        }

        document.getElementById('app').className = "nohighlight";
        Object.assign((this.clone as HTMLElement).style,{
            left:`${this.cloneXY.x}px`,
            top:`${this.cloneXY.y}px`
        });

        this.hoveredElem = (document.elementFromPoint(event.pageX, event.pageY) as HTMLElement);
        let found:boolean = false;

        do{
            if(this.hoveredElem.dataset && this.hoveredElem.dataset.movedestination){
                found = true;
                let contentElement = this.hoveredElem.getElementsByClassName("_content")[0];
                let children = contentElement.getElementsByClassName('g_moveable');
                if(children.length > 0){
                    let templateSet = false;
                    for(let i=0; i<children.length;i++){
                        let bounds = children[i].getBoundingClientRect();
                        if(this.cloneXY.y < bounds.top){
                            contentElement.insertBefore(this.template, children[i]);
                            this.toInsertBefore = i;
                            templateSet = true;
                            break;
                        }
                    }
                    if(!templateSet){
                        contentElement.appendChild(this.template);
                        this.toInsertBefore = null
                    }
                }else{
                    this.toInsertBefore = null
                    contentElement.appendChild(this.template);
                }
            }else if(this.hoveredElem.parentElement){
                this.hoveredElem = this.hoveredElem.parentElement;
            }else{
                // HOVERED ELEMENT AND NO PARENTS ARE DESTINATIONS
                found = true;
                this.cloneable.parentNode.insertBefore(this.template, this.cloneable)
            }
        }while(found == false);
    }
    
    stopDrop(){
        this.hidden = false;
        this.clone.remove();
        this.template.remove();
    }

    async dropItem(event:MouseEvent){
        document.getElementById('app').className = null; // reset highlightable

        this.killEvents();
        let newDestination = null;
        let shouldProgress = true;
        
        if(this.hoveredElem && this.hoveredElem.dataset.movedestination){
            newDestination = moment(this.hoveredElem.dataset.movedestination, "DD/MM/YYYY").toDate();
        }else{
            this.stopDrop();
            return;
        }

        if((this.$children[0] as calItem).completeStages > 0 && (newDestination.getTime() != (this.parentMoveDestination as Date).getTime())){
            setTimeout(() => {
                frontendClient.giveError("Job is complete or partially complete - It cannot be moved");
            },0)
            shouldProgress = false;
        }else if((this.$children[0] as calItem).hasChildren() && (newDestination.getTime() != (this.parentMoveDestination as Date).getTime())){
            let warning = new warningPopup();
            let warningItem:WarningInterface = {
                text:"Moving this job will unappoint all staff associated with it. Are you sure you wish to proceed?",
                options:[
                    {
                        text:"MOVE THE JOB",
                        function: "resolve"
                    },
                    {
                        text: "NO",
                        function: "reject"
                    }
                ]
            }
            await warning.create(this, warningItem).then(() => {
                return true;
            }).catch(() => {
                shouldProgress = false;
            });
        }

        if(!shouldProgress){
            this.stopDrop();
            return;
        }

        Object.assign((this.clone as HTMLElement).style,{
            left:`${this.template.getBoundingClientRect().left}px`,
            top:`${this.template.getBoundingClientRect().top}px`,
            transform: 'scale(1)',
            width: `${(this.template as HTMLElement).offsetWidth}px`
        });


        // CONTINUES IF APPLICABLE DESTINATION
        (this.clone as HTMLElement).style.transition = "all 0.2s cubic-bezier(0.075, 0.82, 0.165, 1)";
        nextTick(() => {
            frontendClient.giveError("Saving...");
        })

        if(this.multiple && (newDestination.getTime() != (this.parentMoveDestination as Date).getTime())){
            let warning = new warningPopup();
            let warningItem:WarningInterface = {
                text:"The job you are moving is allocated to multiple days, moving it shall condense it to a single day. Do you wish to proceed?",
                options:[
                    {
                        text:"MOVE THE JOB",
                        function: "resolve"
                    },
                    {
                        text: "NO",
                        function: "reject"
                    }
                ]
            }
            let shouldContinue = await warning.create(this, warningItem).then(() => {
                return true;
            }).catch(() => {
                this.stopDrop();
                return false;
            });

            if(!shouldContinue){
                return;
            }
        }


        if(newDestination.getTime() != (this.parentMoveDestination as Date).getTime()){
            (this.clone.getElementsByClassName('_walkers')[0] as HTMLElement).style.display ="none";
            ((this.template as HTMLElement).getElementsByClassName('_walkers')[0] as HTMLElement).style.display ="none";
            ((this.cloneable as HTMLElement).getElementsByClassName('_walkers')[0] as HTMLElement).style.display ="none";
            this.parentMoveDestination = newDestination;
        }
         
        setTimeout(() => {
            this.stopDrop();
            let el = this.$el;
            if(typeof this.hoveredElem.dataset.movedestination !== "undefined") {
                let contentElement = this.hoveredElem.getElementsByClassName("_content")[0];
                if(this.toInsertBefore != null){
                    let targetEl = contentElement.getElementsByClassName('g_moveable')[this.toInsertBefore];
                    contentElement.insertBefore(this.cloneable, targetEl);
                    this.$emit("reordered", (this.cloneable as HTMLElement).dataset.uniqueid, (targetEl as HTMLElement).dataset.uniqueid);
                }else{
                    contentElement.appendChild(this.cloneable)
                    this.$emit("reordered", (this.cloneable as HTMLElement).dataset.uniqueid, false);
                }
            }
            this.toInsertBefore = null;
            this.$emit("moved")
        },275);
    }

    killEvents(){
        document.removeEventListener('mousemove', this.controlMove);
        document.removeEventListener('mouseup', this.dropItem);
    }

    openItem(event:MouseEvent){
        if(event.which == 1){
            this.clicked = true;
            this.$emit('openItem');
        }
    }

}

